import {
  AutoComplete,
  FormInput,
  SwitchInput,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo } from "react";
import { busUsersList } from "../../../../../../../services/accessToken.service";
import { useTranslation } from "react-i18next";
import { TIServiceForm } from "../../iServiceSchema";
import { useWatch } from "react-hook-form";

interface IBusInternalTokenProps {
  namePrefix: string;
}

const FIELD_NAME = "busInternalToken";

const translationPath = "page.4uBus.register.iService.";

export const BusInternalToken = memo(
  ({ namePrefix }: IBusInternalTokenProps) => {
    const { t } = useTranslation();

    const { setValue, control } = useFormContext<TIServiceForm>();

    const getName = (fieldName: string) => `${namePrefix}.${fieldName}`;

    const uBusUserExternal = useWatch({
      control,
      name: `${FIELD_NAME}.uBusUserExternal`,
    });

    return (
      <>
        <Grid item xs={12}>
          <SwitchInput
            name={getName("uBusUserExternal")}
            label={t(translationPath + "u_bus_user_external")}
            onValueChange={() => {
              setValue(`${FIELD_NAME}.token`, null);
              setValue(`${FIELD_NAME}.host`, null);
              setValue(`${FIELD_NAME}.busInternalToken`, null);
            }}
          />
        </Grid>
        {uBusUserExternal && (
          <>
            <Grid item xs={12} sm={6}>
              <FormInput
                size="small"
                name={getName("token")}
                label={t(translationPath + "token")}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormInput
                size="small"
                name={getName("host")}
                label={t(translationPath + "host")}
                fullWidth
              />
            </Grid>
          </>
        )}
        {!uBusUserExternal && (
          <Grid item xs={12} sm={6}>
            <AutoComplete
              size="small"
              name={getName("busInternalToken")}
              request={busUsersList}
              label={t(translationPath + "bus_internal_token")}
              getOptionLabel={(option) => option.name}
              fullWidth
            />
          </Grid>
        )}
      </>
    );
  },
);
